import React, { useState } from "react";

import { Link } from "react-router-dom";

import "./BusinessModal.css";

export default function ServiceModal() {
  return (
    <div>
      <div className="col-md-12 col-sm-12 col-xs-12">
        <h2 className="submenu-h2-heading mb10">Businesses </h2>
      </div>

      <div id="business-container" className="container">
        <div className="row g-2">
          <div className="col-6">
            
            <div className="row">
              <Link to="/asp-business-one" className="abc">
                Communication Services
              </Link>
            </div>{" "}
            <hr />
            <div className="row">
              <Link to="/hana" className="abc">
                Financial Services
              </Link>
            </div>{" "}
            <hr />
            <div className="row">
              <Link to="/bo-bi" className="abc">
                Public Sector
              </Link>
            </div>{" "}
            <hr />
            <div className="row">
              <Link to="/iot-integration" className="abc">
                Automotive
              </Link>
            </div>{" "}
            <hr />
            <div className="row">
              <Link to="/customization-consulting" className="abc">
                {" "}
                Education
              </Link>
            </div>{" "}
            <hr />
          </div>

          <div className="col-6">
           
            <div className="row">
              <Link to="/developement" className="abc">
                Helthcare
              </Link>
            </div>{" "}
            <hr />
            <div className="row">
              <Link to="/bpo-kpo" className="abc">
                Information Services
              </Link>
            </div>{" "}
            <hr />
            <div className="row">
              <Link to="/cloud-services" className="abc">
                Logistics & Supplychain
              </Link>
            </div>{" "}
            <hr />
            <div className="row">
              <Link to="/sap-consultants" className="abc">
                Retail & Ecommerce
              </Link>
            </div>{" "}
            <hr />
            <div className="row">
              <Link to="/ecu-iot" className="abc">
                Digital Marketing & Strategy
              </Link>
            </div>{" "}
            <hr />
          </div>
        </div>
      </div>
    </div>
  );
}
